<template>
  <div
    v-if="price"
    :class="[
      'price_block',
      useCards ? 'card' : ''
    ]"
  >
    <!-- TODO: Proper radios? -->
    <div v-if="showMonthlyPrice">
      <product-currency-input
        placeholder="Monthly price"
        :is-support-product="isSupportProduct"
        :price-in-pence="price.monthlyRaw"
        :message="
          (
            minimumPriceData('MONTH').minimum > 0
              ? 'Minimum monthly price:'
              : 'No minimum monthly price'
          )
        "
        :message-popup-content="messagePopupContent"
        :currency="price.currency"
        :currency-symbol="currencySymbol"
        :minimum-price-data="minimumPriceData('MONTH')"
        :error-string="!generalErrorString ? errors.monthly : ''"
        @change="(value) => emitChange({
          currencyCode,
          monthly: value,
        })"
      />
    </div>
    <div v-if="showAnnualPrice">
      <product-currency-input
        placeholder="Annual price"
        :is-support-product="isSupportProduct"
        :price-in-pence="price.annualRaw"
        :message="
          minimumPriceData('YEAR').minimum > 0
            ? 'Minimum annual price:'
            : 'No minimum annual price'
        "
        :message-popup-content="messagePopupContent"
        :currency="price.currency"
        :currency-symbol="currencySymbol"
        :minimum-price-data="minimumPriceData('YEAR')"
        :error-string="!generalErrorString ? errors.annual : ''"
        @change="(value) => emitChange({
          currencyCode,
          annual: value,
        })"
      />
    </div>
    <small
      v-if="generalErrorString"
      class="text-danger"
      v-html="generalErrorString"
    />
  </div>
</template>

<script>
import ProductCurrencyInput from "./ProductCurrencyInput";
import { mapActions, mapGetters } from "vuex";
import _ from 'lodash';

export default {
  components: {
    ProductCurrencyInput,
  },
  props: {
    isSupportProduct: {
      type: Boolean,
      default: false,
    },
    generalErrorString: {
      type: String,
      default: '',
    },
    errors: {
      type: Object,
      default: () => ({
        monthly: null,
        annual: null,
      }),
    },
    showCurrency: {
      type: Boolean,
      default: false,
    },
    showMonthlyPrice: {
      type: Boolean,
      default: true,
    },
    showAnnualPrice: {
      type: Boolean,
      default: true,
    },
    price: {
      type: Object,
      required: true,
    },
    currencyCode: {
      type: String,
      required: true,
    },
    changeMethod: {
      type: String,
      required: true,
    },
    useCards: {
      type: Boolean,
      default: false,
    },
    minimumPrices: {
      type: Object,
      default: null,
    },
    messagePopupContent: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('merchantCentreSetupWizard', [
      'formFields',
    ]),
    ...mapGetters('productManager', [
      'softwarePrices',
      'softwareProduct',
    ]),
    currencySymbol() {
      return this.currencyCode === 'GBP' ?
        '&pound;' :
        '&dollar;';
    },
  },
  methods: {
    ...mapActions('productManager', [
      'setSoftwareProductPriceField',
      'setSupportAddonPriceField',
      'validateSoftwareProduct',
      'validateSupportAddon',
    ]),
    emitChange(payload) {
      this[this.changeMethod](payload);
    },
    showInput(currency, billingPeriod) {
      const { prices } = this.softwareProduct;

      const monthlyRequired = prices[0].monthly > 0 || prices[1].monthly > 0;
      const annualRequired = prices[0].annual > 0 || prices[1].annual > 0;

      const gbpPriceIndex = _.findIndex(prices, { currency: 'GBP' });
      const usdPriceIndex = _.findIndex(prices, { currency: 'USD' });

      const gbpRequired = prices[gbpPriceIndex].monthly > 0 || prices[gbpPriceIndex].annual;
      const usdRequired = prices[usdPriceIndex].monthly > 0 || prices[usdPriceIndex].monthly;

      return (
        (currency === 'GBP' && gbpRequired) ||
        (currency === 'USD' && usdRequired)
      ) && (
        (billingPeriod === 'MONTH' && monthlyRequired) ||
        (billingPeriod === 'YEAR' && annualRequired)
      );
    },
    minimumPriceData(billingPeriod) {
      const {currencyCode} = this;
      if (this.minimumPrices && this.minimumPrices[currencyCode]) {
        return this.minimumPrices[currencyCode][billingPeriod];
      }

      return {
        minimum: 0,
      };
    },
  }
}
</script>

<style lang="scss" scoped>
.price_block {
  margin-bottom: 1rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 16px;
  transition: .3s;

  &:last-of-type {
    margin-bottom: 0;
  }
}

.select_type {
  cursor: pointer;
  display: inline-block;

  .temp_radio {
    display: inline-block;
    text-align: center;
    padding: 2px;
    border: 1px solid #37B2A8;
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;
    color: white;
    border-radius: 6px;

    &.active {
      background: #37B2A8;
      border: 0;
    }
  }

  label {
    font-size: 1.125rem;
    font-weight: 500;
    cursor: pointer !important;
  }
}
</style>
